<div class="card card-xs h-100 box-shadow-none" [class.card-clickable]="clickable">
  <div class="card-body">
    <i *ngIf="info" class="kpi-info fa-sharp fa-solid fa-circle-question text-muted"></i>
    <p class="kpi-label small fw-bold mb-1 oneline" [class.has-info]="info">{{ label }}</p>
    <h3 class="mb-0"><ng-content></ng-content></h3>
  </div>
</div>
